import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Dialog, { DialogContent } from '@eversports/klimt-primitives/legacy/Dialog'
import { useRef } from 'react'

import Drawer from '../../../../components/Drawer'

import { VenueReferAFriendOverlayContent } from './VenueReferAFriendOverlayContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
  venueName: string
  referralCode: string
  rewardDescription: string
}

export function VenueReferAFriendOverlay({ isOpen, toggleDialog, venueName, referralCode, rewardDescription }: Props) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const hasOpenedRef = useRef(false)

  if (isOpen) {
    hasOpenedRef.current = true
  }

  if (!hasOpenedRef.current) return null

  return isMobile ? (
    <Drawer open={isOpen} onClose={toggleDialog}>
      <VenueReferAFriendOverlayContent
        venueName={venueName}
        referralCode={referralCode}
        rewardDescription={rewardDescription}
      />
    </Drawer>
  ) : (
    <Dialog open={isOpen} onClose={toggleDialog} maxWidth={false}>
      <DialogContent>
        <VenueReferAFriendOverlayContent
          venueName={venueName}
          referralCode={referralCode}
          rewardDescription={rewardDescription}
        />
      </DialogContent>
    </Dialog>
  )
}
